@if (this.state.orderPosted ||
  config.property !== 'acceptTermsAndConditions') {
  <div class="{{config.property}} wb-{{config.type}} {{erroneous ? 'wb-active' : ''}}">
    @for (error of errors; track error) {
      @if (error.text) {
        <span [class]="(error.helpText === 'address_field_error_work_area' ? 'inline' : '')"
          (click)="(error.helpText ? toggleHelpModal(error.text, error.helpText) : null)">
          {{error.text | translate | ucFirst}}
        </span>
      }
      @if (error.helpText && error.helpText === 'address_field_error_work_area') {
        <span class="wb-help" (click)="toggleHelpModal(error.text, error.helpText)">
          <span class="underline inline">{{'address_field_error_work_area_link' | translate | ucFirst}}</span>
        </span>
      }
    }
  </div>
}
